import type { ReactNode } from "react";
import { useNavigate } from "react-router";
import { ChevronLeftIcon } from "./icons.js";

/**
 * 顶部导航。
 *
 * `back` 为真时左侧是返回箭头；否则左侧可以放任意内容（首页放头像）。
 * `center` 让标题居中、左右绝对定位（详情页 / 设置子页用）。
 */
export function NavBar({
  title,
  back = false,
  onBack,
  left,
  right,
  center = false,
}: {
  title: ReactNode;
  back?: boolean;
  onBack?: () => void;
  left?: ReactNode;
  right?: ReactNode;
  center?: boolean;
}) {
  const navigate = useNavigate();
  const handleBack = onBack ?? (() => navigate(-1));

  return (
    <header className={center ? "navbar center" : "navbar"}>
      <div className="navbar-left">
        {back && (
          <button
            type="button"
            className="icon-btn"
            onClick={handleBack}
            aria-label="返回"
          >
            <ChevronLeftIcon size={22} />
          </button>
        )}
        {left}
      </div>
      <h1 className="navbar-title">{title}</h1>
      <div className="navbar-right">{right}</div>
    </header>
  );
}
